export const handleChangeInputInstallmentsFactorPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_INSTALLMENTS_FACTOR', name, value
});